<template>
	<div>
		<h5>ReSelectMap</h5>
	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
	export default {
		name: 'ReSelectMap',
		components: {

		},
		props: {
			counter: String,
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>

</style>
